import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { ReferrerDashboard } from "@/components/dashboard/ReferrerDashboard";

export default function Dashboard() {
  return (
    <ProtectedRoute>
      <ReferrerDashboard />
    </ProtectedRoute>
  );
}
